import { createContext, useCallback, useContext, useRef, type ReactNode } from 'react';
import { Toast, type ToastMessage, type ToastRef } from '@uigovpe/components';

interface ToastContextValue {
  showToast: (message: ToastMessage) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

/** Toast único no topo da árvore — qualquer componente avisa o cidadão via `useToast()`, sem precisar receber a ref por prop. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const toastRef = useRef<ToastRef>(null);

  const showToast = useCallback((message: ToastMessage) => {
    toastRef.current?.show({ life: 4000, ...message });
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toast ref={toastRef} position="top-right" />
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast precisa ser usado dentro de um ToastProvider.');
  return context;
}
